import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CruiseBookingObject } from '../modules/booking-flow/cruise/cruise-booking-page/interfaces/icruise-booking-object-interface';

@Injectable({
  providedIn: 'root'
})
export class BookingObjectService {

  private bookingObjectSubject$: BehaviorSubject<CruiseBookingObject>;

  constructor() {
    this.bookingObjectSubject$ = new BehaviorSubject( null);
  }

  get bookingObject(): CruiseBookingObject {
    return this.bookingObjectSubject$.getValue();
  }

  set bookingObject(value: CruiseBookingObject) {
    this.bookingObjectSubject$.next(value);
  }
}
